import { getStatusBadgeStyle } from '../../../../utils/statusBadgeStyle';

/**
 * Status chip for the reporting side panels (Prior Reports / Report History).
 *
 * Same solid fills as the study-list badge (utils/statusBadgeStyle) so a status
 * reads the same colour here as in the PACS list; only the geometry is smaller
 * to fit the narrow panel rows.
 */
const CHIP_GEOMETRY: React.CSSProperties = {
  height: '1.25rem',
  fontSize: '0.75rem',
  lineHeight: '1.25rem',
  padding: '0 0.375rem',
  minWidth: 'auto',
};

// Report-only state with no list equivalent — keep it neutral.
const AUTOSAVED_COLORS: React.CSSProperties = {
  background: '#EEF2F7',
  color: '#475569',
  borderColor: '#CBD5E1',
};

export const getStatusStyle = (status: string | undefined): React.CSSProperties => ({
  ...getStatusBadgeStyle(status),
  ...(status?.toUpperCase() === 'AUTOSAVED' ? AUTOSAVED_COLORS : null),
  ...CHIP_GEOMETRY,
});
